import { put, take } from 'redux-saga/effects';
import {
  starStepFetching,
  stopStepFetching,
} from 'modules/Taps/components/NDFL3Light/redux/actions';
import {
  actionTypes as taxesActionTypes,
  startRequest as getTaxes,
} from 'modules/NewTaxes/redux/taxes/actions';

/**
 * Overpayments init step worker
 * @returns {IterableIterator<*>}
 */
export default function* initOverpaymentsSaga() {
  yield put(starStepFetching());

  yield put(getTaxes());
  yield take(taxesActionTypes.REQUEST_SUCCESS);

  yield put(stopStepFetching());
}
